export const FORM_OFFERS_TYPES_OPTIONS = [
  { text: "Selecione...", value: null },
  { text: "Combo", value: "combo", module: "plan" },
  { text: "Plano", value: "plan", module: "plan" },
  { text: "SVA", value: "sva", module: "service-additional" }
]
export const FORM_OFFERS_TYPES = {
  COMBO: "combo",
  PLAN: "plan",
  SVA: "sva"
}

export const PERSON_TYPE = {
  PHYSICAL: "FISICA",
  LEGAL: "JURIDICA"
}

export const CATEGORY_TYPE = {
  MOBILE: "Móvel",
  TV: "TV",
  CHIP: "Chip",
}

export const PRICE_INITIAL = "0,00"

export const MAX_SIZE_ICON = 500000

export const MAX_INTEGER_VALUE = 4294967295

export const MAX_INTEGER_VALUE_FORMMATED = "R$ 42.949.672,95"

export const CAMPAIGN_STEP = 3

export const CREATED_THROUGH = {
  INTEGRATION: "Integração",
  MANUAL: "Manual"
}

export const COVERAGE_OPTIONS = [
  {
    title: "Estado",
    type: "state",
    amount: 0,
    active: false
  },
  {
    title: "Cidade",
    type: "city",
    amount: 0,
    active: false
  },
  {
    title: "DDD",
    type: "ddd",
    amount: 0,
    active: false
  }
]

export const COVERAGE_TYPE = {
  state: "state",
  city: "city",
  ddd: "ddd"
}

export const ACCESS_OPTIONS = [
  {
    title: "Rede",
    type: "chain",
    amount: 0,
    active: false
  },
  {
    title: "PDV",
    type: "pos",
    amount: 0,
    active: false
  }
]

export const ACCESS_TYPE = {
  chain: "chain",
  pdv: "pos"
}

export const PERSON_TYPES = {
  physical: "FISICA",
  legal: "JURIDICA"
}

export const SVA_ICON_ALLOWED_EXTENSIONS = ["png"]

export const STEPS = ["Ofertas", "Categorias", "Campanhas", "SVA's"]

export const STEPS_INDEXES = {
  1: "plan-offers",
  2: "plan-categories",
  3: "plan-campaigns",
  4: "plan-svas"
}

export const CREATE_ROUTE_TO = {
  1: "plan-form-offers",
  2: "plan-form-categories",
  3: "plan-form-campaigns",
  4: "plan-form-offers"
}

export const OFFERS_TYPES_ROUTE_TO_EDIT = {
  PLAN: "plan",
  PACKAGED: "combo"
}

export const OFFERS_TYPES = [
  {
    display_name: "Plano",
    value: "PLAN",
    searchable: "category"
  },
  {
    display_name: "Combo",
    value: "PACKAGED",
    searchable: "category"
  }
]

export const OFFER_TYPES_PT = {
  PLAN: "Plano",
  PACKAGED: "Combo"
}

export const LIST_PERMISSIONS = {
  1: "plan",
  2: "service-type",
  3: "campaign",
  4: "service-additional"
}

export const OPTIONS_STATUS_FILTER = [
  { text: "Ativo", value: 1 },
  { text: "Inativo", value: 0 }
]

export const STATUS_ACTIVE = 1
export const STATUS_INACTIVE = 0

export const INACTIVATE_PACKAGES = 1
export const KEEP_PACKAGES = 0
